import axios from "axios";
import { getApiBaseUrl } from "../utils/apiConfig";

// Use environment variable for API base URL, fallback to localhost for development
const API_BASE_URL = getApiBaseUrl();

const API = axios.create({ baseURL: API_BASE_URL });

// Add request interceptor to include auth token if available
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Case APIs
export const fetchCases = () => API.get("/cases");
export const createCase = (data) => API.post("/cases", data);

export default API;
